/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2018 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
import React from "react";
import {
  ResponsiveGrid,
  MapTo,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";

export class VisualizerTab extends ResponsiveGrid {
  /**
   * The attributes that will be injected in the root element of the container
   *
   * @returns {Object} - the attributes of the container
   */
  get containerProps() {
    let containerProps = super.containerProps;
    containerProps.className =
      (containerProps.className || "") +
      " VisualizerTab " +
      this.props.gridClassNames;
    return containerProps;
  }

  render() {
    return (
      <div {...this.containerProps}>
        <p>Visualizer Tab</p>
        {super.childComponents}
        {super.placeholderComponent}
      </div>
    );
  }
}

export default MapTo("lexus/components/visualizer/data-dialogs/tab")(
  withComponentMappingContext(VisualizerTab)
);
